export default __webpack_public_path__ + "static/media/csv-file.f5483d0a.png";